import { Action, handleActions } from 'redux-actions'
import { UserPreferenceDto } from '../../../services/api.types'
import {
  editUserPreferencesFail,
  editUserPreferencesSuccess,
  getUserPreferences,
  getUserPreferencesFail,
  getUserPreferencesSuccess,
} from './NotificationPreferencesActions'

class State {
  list: UserPreferenceDto[] = []
  isLoading: boolean = false
  lastUpdate: number | null = null
}

export const userPreferences = handleActions<State, any>(
  {
    [String(getUserPreferences)]: (state: State): State => ({
      ...state,
      isLoading: true,
    }),
    [String(getUserPreferencesSuccess)]: (state: State, action: Action<UserPreferenceDto[]>): State => ({
      ...state,
      list: action.payload,
      isLoading: false,
    }),
    [String(getUserPreferencesFail)]: (state: State): State => ({
      ...state,
      isLoading: false,
    }),

    [String(editUserPreferencesSuccess)]: (state: State): State => ({
      ...state,
      lastUpdate: new Date().getTime(),
    }),

    [String(editUserPreferencesFail)]: (state: State): State => ({
      ...state,
      lastUpdate: new Date().getTime(),
    }),
  },
  new State(),
)

export { State as UserPreferencesState }
